import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

export async function getEmailTemplates(bid) {
  try {
    const emailTemplateCollection = await collection(db, "emailTemplates");
    console.log("emailTemplateCollection: ", emailTemplateCollection);

    let q = query(emailTemplateCollection, where("type", "==", "email"));
    console.log("q: ", q);
    const emailSnapshot = await getDocs(q);
    console.log("emailSnapshot: ", emailSnapshot);
    let emails = [];
    emailSnapshot.docs.forEach((doc) => {
      emails.push(doc.data());
    });
    return emails;
  } catch (ex) {
    console.log(ex);
    return [];
  }
}
